import React from "react";

import { Impulse } from "~/tools/impulse";
import { usePermanent } from "~/tools/use-permanent";

import { WidgetExpandContextProvider } from "./widget-context";

export const WidgetBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
	const value = usePermanent(() => Impulse(new Map<string, boolean>()));

	return <WidgetExpandContextProvider value={value}>{children}</WidgetExpandContextProvider>;
};
